import React from 'react';
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Skeleton } from "@/components/ui/skeleton";

export function ProjectModalSkeleton() {
  return (
    <div className="flex flex-col h-full animate-in fade-in-0 duration-300">
      {/* Header Skeleton */}
      <div className="flex items-center justify-between p-6 border-b bg-background">
        <div className="flex items-center gap-3">
          <Skeleton className="h-8 w-8 rounded" />
          <div>
            <Skeleton className="h-6 w-48 mb-2" />
            <Skeleton className="h-4 w-32" />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-8 rounded" />
          <Skeleton className="h-8 w-8 rounded" />
        </div>
      </div>

      {/* Status Bar Skeleton */}
      <div className="px-6 py-3 border-b bg-muted/30">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Skeleton className="h-6 w-24" />
            <Skeleton className="h-6 w-32" />
            <Skeleton className="h-6 w-28" />
          </div>
          <Skeleton className="h-8 w-24 rounded" />
        </div>
      </div>

      {/* Tabs Skeleton */}
      <div className="border-b bg-background">
        <div className="px-6">
          <Tabs defaultValue="overview" className="w-full">
            <TabsList className="h-12 bg-transparent p-0 w-full justify-start rounded-none border-b-0">
              {['Overview', 'Communication', 'Finance', 'Documents', 'Tasks'].map((tab) => (
                <TabsTrigger
                  key={tab}
                  value={tab.toLowerCase()}
                  disabled
                  className="h-12 rounded-none border-b-2 border-transparent px-4 opacity-50"
                >
                  <Skeleton className="h-4 w-20" />
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        </div>
      </div>

      {/* Content Area Skeleton */}
      <div className="flex-1 overflow-hidden">
        <div className="p-6 space-y-6">
          {/* Info Cards Row */}
          <div className="grid grid-cols-3 gap-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="p-4 border rounded-lg">
                <Skeleton className="h-4 w-24 mb-2" />
                <Skeleton className="h-6 w-32" />
              </div>
            ))}
          </div>

          {/* Main Content Sections */}
          <div className="space-y-4">
            <div className="p-4 border rounded-lg">
              <Skeleton className="h-5 w-32 mb-3" />
              <div className="space-y-2">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-4/5" />
                <Skeleton className="h-4 w-3/4" />
              </div>
            </div>

            <div className="p-4 border rounded-lg">
              <Skeleton className="h-5 w-40 mb-3" />
              <div className="grid grid-cols-2 gap-4">
                <Skeleton className="h-20" />
                <Skeleton className="h-20" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Skeleton */}
      <div className="border-t p-4 bg-background">
        <div className="flex justify-between items-center">
          <Skeleton className="h-4 w-48" />
          <div className="flex gap-2">
            <Skeleton className="h-9 w-24 rounded" />
            <Skeleton className="h-9 w-20 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
}